import { createSelector } from 'reselect'

const getSummary = (state: any) =>
  (state && state.entities && state.entities.vehicleSummaryCache && state.entities.vehicleSummaryCache.byId) || {}

export default createSelector(getSummary, (summaries) => (id: string | undefined) => {
  return id ? (summaries[id] as Cinch.DirectVehicleSummaryResponse) : null
})
